const _temp0 = require("../img/arrow-dark.svg");
const _temp1 = require("../img/arrow-down.svg");
const _temp2 = require("../img/arrow-right.svg");
const _temp3 = require("../img/arrow-up.svg");
const _temp4 = require("../img/arrow.svg");
const _temp5 = require("../img/avatar.png");
const _temp6 = require("../img/case-1.png");
const _temp7 = require("../img/case-2.png");
const _temp8 = require("../img/case-3.png");
const _temp9 = require("../img/case-4.png");
const _temp10 = require("../img/case-studies-vector.svg");
const _temp11 = require("../img/check.svg");
const _temp12 = require("../img/copy.svg");
const _temp13 = require("../img/emotional-vector.svg");
const _temp14 = require("../img/flag.png");
const _temp15 = require("../img/footer-orange-vector.svg");
const _temp16 = require("../img/footer-purple-vector.svg");
const _temp17 = require("../img/hand.svg");
const _temp18 = require("../img/heart.svg");
const _temp19 = require("../img/human-friendly-vector.svg");
const _temp20 = require("../img/new.svg");
const _temp21 = require("../img/plane.svg");
const _temp22 = require("../img/ui.svg");
const _temp23 = require("../img/ux.svg");
module.exports = {
  "arrow-dark.svg": _temp0,
  "arrow-down.svg": _temp1,
  "arrow-right.svg": _temp2,
  "arrow-up.svg": _temp3,
  "arrow.svg": _temp4,
  "avatar.png": _temp5,
  "case-1.png": _temp6,
  "case-2.png": _temp7,
  "case-3.png": _temp8,
  "case-4.png": _temp9,
  "case-studies-vector.svg": _temp10,
  "check.svg": _temp11,
  "copy.svg": _temp12,
  "emotional-vector.svg": _temp13,
  "flag.png": _temp14,
  "footer-orange-vector.svg": _temp15,
  "footer-purple-vector.svg": _temp16,
  "hand.svg": _temp17,
  "heart.svg": _temp18,
  "human-friendly-vector.svg": _temp19,
  "new.svg": _temp20,
  "plane.svg": _temp21,
  "ui.svg": _temp22,
  "ux.svg": _temp23
}